import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { gameActions } from "../../store/game-slice";

function ClockTimer(props) {
  const dispatch = useDispatch();

  const [time, setTime] = useState(0);
  const [timerOutput, setTimerOutput] = useState("0:00:00");
  const [bestTimes, setBestTimes] = useState([]);

  // Hours calculation
  const hours = Math.floor(time / 360000);

  // Minutes calculation
  const minutes = Math.floor((time % 360000) / 6000);

  // Seconds calculation
  const seconds = Math.floor((time % 6000) / 100);

  const tick = useRef();

  useEffect(() => {

    if(props.isGameRestarted) {
      setTime(0);

      const times = JSON.parse(localStorage.getItem("times"));
      if(times != null) {
        setBestTimes(times);
      } else {
        setBestTimes([]);
      }
    }

    if (props.isGameWon) {
      dispatch(gameActions.setGameWon(false));
      dispatch(gameActions.setFinalGameTime(timerOutput));
      let times = JSON.parse(localStorage.getItem("times"));
      if (times) {
        times.push(timerOutput);
      } else {
        times = new Array();
        times.push(timerOutput);
      }
      localStorage.setItem("times", JSON.stringify(times));
    }

    if (props.startClock) {
      setTime(0);
      tick.current = setInterval(() => setTime((time) => time + 1), 10);
      dispatch(gameActions.setStartClock(false));
    }

    return () => {
      if (!props.isClockRunning) {
        clearInterval(tick.current);
      }
    };
  }, [
    dispatch,
    props.startClock,
    props.isClockRunning,
    props.isGameWon,
    props.isGameRestarted,
    time,
    hours,
    minutes,
    seconds,
    timerOutput
  ]);

  useEffect(() => {
    let tempTimerOutput =
      hours +
      ":" +
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0");
    setTimerOutput(tempTimerOutput);
  }, [dispatch, time, hours, minutes, seconds]);

  return <div className="game-timer">GAME {(bestTimes.length+1)} <strong>{timerOutput}</strong></div>;
}

export default ClockTimer;
